import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import DriveEndType from "../../enums/drive-end-type";

export default class UpdateContext extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.UpdateContext;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamId } = gameContext;
        const { values } = fragment;
        const {
            awayScore,
            down,
            fieldPosition,
            firstDownAt,
            homeScore,
            teamPossession
        } = values;

        const previousHomePossession = gameContext.homeTeamHasPossession;

        gameContext.setFieldPosition(Number(fieldPosition));
        gameContext.down = Number(down);
        gameContext.firstDownAt = Number(firstDownAt);
        gameContext.homeTeamHasPossession = homeTeamId === teamPossession;
        gameContext.score = [Number(homeScore), Number(awayScore)];
        gameContext.triggerPAT = false;

        // A manual field update that flips possession is a takeover (e.g. the
        // operator hand-entering a turnover or a blocked-kick recovery): the
        // other team starts a new drive. Mirror Turnover so a new drive is cut
        // instead of the takeover plays inheriting the prior team's drive.
        // Gated strictly on the flip so non-possession field edits are untouched.
        if (gameContext.homeTeamHasPossession !== previousHomePossession) {
            gameContext.setDriveContext({
                ...gameContext.getDriveContext(),
                previousDriveEndType: DriveEndType.Turnover,
                triggerDrive: true
            });
            gameContext.currentDriveId = null;
        }
    }
}
